export default __webpack_public_path__ + "static/solutions-a9a2dd60104978c5ca3f70f20bb715e9.png";